var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    height: "17px",
    width: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5BB3C7",
    d: "M9.7,17c-0.4-0.1-0.6-0.3-0.7-0.7c0-0.1,0-0.2,0-0.2c0-0.7,0-1.5,0-2.2c-0.1,0-0.1,0-0.2,0 c-1.2,0-2.5,0-3.7,0c-0.7,0-1-0.3-1-1c0-0.4,0-0.8,0-1.2c0-0.4,0.4-0.8,0.8-0.9c0.5,0,0.9,0.2,1,0.6c0,0.1,0,0.2,0,0.3 c0,0.1,0,0.3,0,0.4c1,0,2.1,0,3.1,0c0-0.1,0-0.1,0-0.2c0-2.4,0-4.8,0-7.2C9,4.3,9.2,4,9.5,3.8c1-0.7,2-1.3,3-2 c0.1,0,0.1-0.1,0.2-0.1c-2.3,0-4.5,0-6.8,0c0,0.2,0,0.3,0,0.5c0,0.5-0.3,0.8-0.8,0.9c-0.4,0.1-0.8-0.2-1-0.6c0,0,0-0.1,0-0.1 c0-0.5,0-1.1,0-1.6C4.2,0.3,4.6,0,5,0C5,0,5,0,5.1,0c3.5,0,7,0,10.5,0c0.4,0,0.7,0.2,0.8,0.5c0,0.1,0.1,0.2,0.1,0.3 c0,4.1,0,8.1,0,12.2c0,0.4-0.2,0.6-0.5,0.8c-1.9,1-3.7,2.1-5.6,3.1c-0.1,0.1-0.2,0.1-0.3,0.1C10,17,9.9,17,9.7,17z M3.7,6.2 C3.9,5.9,4,5.7,3.9,5.4C3.8,5.1,3.6,4.8,3.3,4.8C2.9,4.7,2.6,4.8,2.4,5C1.8,5.6,1.3,6.2,0.7,6.7C0.4,7.1,0.4,7.7,0.7,8 c0.6,0.6,1.1,1.2,1.6,1.7c0.4,0.4,0.9,0.4,1.3,0.1c0.4-0.3,0.4-0.9,0-1.2C3.6,8.5,3.5,8.4,3.4,8.2c0.1,0,0.2,0,0.2,0 c1.2,0,2.5,0,3.7,0c0.1,0,0.2,0,0.3,0c0.4-0.1,0.7-0.5,0.7-1C8.2,6.8,7.8,6.5,7.4,6.5c-1.3,0-2.5,0-3.8,0c-0.1,0-0.1,0-0.2,0 C3.5,6.4,3.6,6.3,3.7,6.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.b288c3836b180bdbb5acc59782ad009d.svg";
export { ForwardRef as ReactComponent };